import { $log } from './debug';
import { YLocationState } from './location';
import { yCopy } from './object';

export namespace $history {
    interface HistoryEntry {
        id: number;
        depth: number;
        state: YLocationState;
    }

    let next_id = new Date().getTime();
    let expected_id = -1;
    let current_entry: HistoryEntry;
    let current_depth = 1;
    type PopMode = 'back' | 'forward' | 'initial';

    type PopCallback = (state: YLocationState, commit: (new_state: YLocationState) => void, cancel: () => void, mode: PopMode) => void;
    let onPopCallback: PopCallback;

    function popStateHandler(this: Window, ev: PopStateEvent) {
        const event_entry = ev.state;
        if(!isValidEntry(event_entry)) {
            $log('navigation', 'state entry is not valid', event_entry);
            return;
        }
        if(event_entry.id == expected_id) {
            expected_id = -1;
            return;
        }
        if(event_entry.id == current_entry.id) {
            $log('navigation', 'it\'s same id... shouldn\'t really happen', event_entry);
            return;
        }
        const mode = event_entry.depth > current_depth ? 'forward' : 'back';
        current_depth = event_entry.depth;
        callPopCallback(event_entry, mode);
    }

    function callPopCallback(pop_entry: HistoryEntry, mode: PopMode) {
        const restore_depth = current_entry.depth;
        const restore_id = current_entry.id;

        onPopCallback(pop_entry.state, replace, () => {
            if(current_depth != restore_depth) {
                expected_id = restore_id;
                history.go(restore_depth - current_depth);
            }
        }, mode);
    }

    function makeNewEntry(state: YLocationState, depth: number): HistoryEntry {
        return { id: next_id++, state: yCopy(state), depth };
    }

    let isValidState: (state: YLocationState) => boolean;

    function isValidEntry(entry: HistoryEntry): entry is HistoryEntry {
        return typeof entry?.id === 'number' && typeof entry.depth === 'number' && isValidState(entry.state);
    }

    let stateToUrl: (state: YLocationState, append_query?: boolean) => string;

    export function init(_onPopCallback: PopCallback, getInitialLocation: () => YLocationState, _stateToUrl: (state: YLocationState, append_query?: boolean) => string, _isValidState: (state: YLocationState) => boolean) {
        window.addEventListener('popstate', popStateHandler);

        onPopCallback = _onPopCallback;
        stateToUrl = _stateToUrl;
        isValidState = _isValidState;

        current_entry = history.state;
        if(!isValidEntry(current_entry))
            current_entry = makeNewEntry(getInitialLocation(), 1);
        current_depth = current_entry.depth;
        callPopCallback(current_entry, 'initial');
    }

    const params_to_save = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid', 'msclkid', 'mc_cid'];

    export function replace(state: YLocationState, append_query?: boolean) {
        current_entry = makeNewEntry(state, current_depth);
        const new_url = new URL(stateToUrl(state, append_query), window.location.href);
        const current_params = Object.fromEntries(new URLSearchParams(window.location.search));

        for(const param of params_to_save) {
            if(param in current_params)
                new_url.searchParams.set(param, current_params[param]);
        }

        history.replaceState(current_entry, '', new_url.href);
    }

    export function push(state: YLocationState) {
        current_entry = makeNewEntry(state, ++current_depth);
        history.pushState(current_entry, '', stateToUrl(state));
    }
}
